"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "placements", {
  enumerable: true,
  get: function get() {
    return _Popover.placements;
  }
});
exports.default = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _designTokens = _interopRequireDefault(require("@decisiv/design-tokens"));

var _color = _interopRequireDefault(require("../../modifiers/color"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _schema = _interopRequireDefault(require("./schema"));

var _Popover = _interopRequireWildcard(require("../Popover"));

var _Typography = require("../Typography");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var colors = (0, _color.default)(_designTokens.default.color.base.charcoal);
var StyledContent = (0, _styledComponents.default)(_Typography.P).attrs({
  as: 'div',
  size: 'small'
}).withConfig({
  displayName: "Tooltip__StyledContent",
  componentId: "ft57is-0"
})(["border-radius:2px;padding:", ";", ";"], "".concat((0, _rem.default)(4), " ").concat((0, _rem.default)(10)), colors);

var Tooltip = function Tooltip(_ref, ref) {
  var id = _ref.id,
      children = _ref.children,
      manageEvents = _ref.manageEvents,
      rest = _objectWithoutProperties(_ref, ["id", "children", "manageEvents"]);

  var uuid = (0, _useUniqueId.default)(id, 'tooltip-');
  return _react.default.createElement(_Popover.default, _extends({}, rest, {
    id: uuid,
    ref: ref,
    arrowColor: "charcoal",
    manageEvents: manageEvents !== false ? 'hover' : false,
    hideOnClickOutside: false
  }), _react.default.createElement(StyledContent, null, children));
};

var TooltipWithRef = (0, _react.forwardRef)(Tooltip); // @ts-ignore

TooltipWithRef.propTypes = _schema.default.propTypes; // @ts-ignore

TooltipWithRef.defaultProps = _Popover.default.defaultProps;
TooltipWithRef.displayName = 'Tooltip';
var _default = TooltipWithRef;
exports.default = _default;